import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { getTcsmEpiProps, setClergyCompensationReportSettings } from '../../global/ducks/epi-api';
import { TcsmStates } from '../../root/tcsm-model';
import { ClergyCompReportSettings } from '../arc/models/arc-epi-props';
import { ClergCompReportDropdown } from './dropdown/clergy-report-dropdown';
import { ClergyCompReportMap } from './map/clergy-comp-report-map';
import { ClergyCompReportNav } from './clergy-comp-report-nav';
import { ClergyCompReportContent } from './content/clergy-comp-report-content';
import { HoverComponent } from './hover-component';
import { setPort } from './clergy-comp-report-slice';
import { EmbedAction } from './reports/embed';
import { ReportContent } from './reports/report-content';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';



function getFrameByEvent(event) {
    // eslint-disable-next-line arrow-body-style
    return [].slice.call(document.getElementsByTagName('iframe')).filter(iframe => {
        return iframe.name === event.data.referenceId;
    })[0];
}


interface Props {
    settingsId: string,
    language: string,
}

export function ClergyCompensationReportApp(props: Props) {
    const dispatch = useDispatch();
    const settingsLoaded = useSelector<TcsmStates, boolean>(state => state?.epiProps?.clergyCompReportSettingsState?.contentLoaded);
    const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);

    useEffect(() => {
        dispatch(getTcsmEpiProps(dispatch, props.settingsId, null, props.language, false, setClergyCompensationReportSettings));
    }, [props.settingsId]);

    useEffect(() => {
        window.addEventListener('message', e => {
            if (e.origin !== 'https://public.domo.com') return;
            const port = e.ports[0];
            if (!port) return;
            const frame = getFrameByEvent(e);
            if (!frame) return;
            if (frame.getAttribute('data-group') !== 'filtered') return;
            const name = frame.getAttribute('name');

            dispatch(setPort(name, port));
        });
    }, []);


    if (!settingsLoaded) {
        return <LoadingCircle />;
    }

    return (

        <div className='clergycomp-wrapper'>
            <div className='clergycomp-infographic-header'>
                <div className=''>
                    <h1>{settings?.landingPageTitle}</h1>
                    <h2>Domestic Dioceses by Province</h2>
                </div>
                <ClergCompReportDropdown />

            </div>
            <div className='clergycomp-infographic'>
                <div className='clergycomp-infographic-image clergycomp-infographic-map'>
                    <ClergyCompReportMap />
                </div>
                <div className='clergycomp-infographic-breadcrumb'>
                    <ClergyCompReportNav />
                </div>
            </div>
            <ContentSpacer>
                <div className='rich-text' dangerouslySetInnerHTML={{ __html: settings?.contentBelowMap }} />
            </ContentSpacer>
            <ClergyCompReportContent />
            <ReportContent />
            <HoverComponent />
            <EmbedAction />
        </div>

    );
}